module.exports = __webpack_public_path__ + "static/media/banner_audi.3fe137ab.jpg";